<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div v-html="blockData.header"></div>
      </div>
    </div>
    <div class="chart-wrapper">
      <div class="row">
        <div class="col-7 col-sm-6 col-md-5">
          <span class="chart-xlabel align-right">Breakdown (%)</span>
        </div>
        <div class="col-5 col-sm-6 col-md-7">
          <div class="chart-xlabel">Relative to index (%)</div>
        </div>
      </div>
      <div class="row">
        <div class="col-7 col-sm-6 col-md-5">
          <div class="chart-ylabel" v-for="(label, index) in this.chartLabels">
            <span class="chart-ylabel__col chart-ylabel__col--1">{{ label }}</span><span
              class="chart-ylabel__col chart-ylabel__col--2">{{ breakdownValuesToStrings[index] }}</span>
          </div>
        </div>
        <div class="col-5 col-sm-6 col-md-7">
          <Bar v-bind:chartLabels="this.chartLabels" v-bind:dataValues="this.dataValues"
            :height="(this.dataValues.length * 30) + 60">
          </Bar>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12" v-html="blockData.footer"></div>
    </div>
  </div>
</template>

<script>
import Bar from './charts/SplitBarChart.vue';

export default {
  components: {
    Bar
  },
  props: {
    blockData: Object
  },
  data: function () {
    return {
      breakdownValues: this.getRowData('value_1'),
      dataValues: this.getRowData('value_2'),
      chartLabels: this.getRowData('label')
    }
  },
  computed: {
    breakdownValuesToStrings: function () {
      return this.breakdownValues.map(function (e) {
        return parseFloat(Math.round(e * 100) / 100).toFixed(1);
      });
    }
  },
  methods: {
    getRowData: function (columnLabel) {
      let values = [];
      this.blockData.rows.forEach(function (row) {
        values.push(row[columnLabel]);
      });
      return values;
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-xlabel {
  text-align: center;
  display: block;
  font-weight: 700;
  margin: 0.3em 0;
}

.chart-xlabel.align-right {
  text-align: right;
}

.chart-ylabel {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 35px;

  .chart-ylabel__col {
    display: block;
    padding: 9px;
  }

  .chart-ylabel__col--2 {
    width: 3em;
    background-color: #e0ecf0;
    text-align: right;
  }
}
</style>
